import React, { Component } from "react";
import { connect } from "react-redux";
import { setUser } from "../../store/actions/auth";
import { ReactComponent as Google } from "./assets/google.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import {
  beginCheckoutSocialAuth,
  buildSocialAuthRedirect,
  parseSocialAuthCallback,
  readCheckoutSocialAuth,
  sanitizeSocialAuthReturnTo,
} from "./socialAuthFlow";

export class GoogleSocialAuth extends Component {
  static defaultProps = { settings: {}, auth: {} };

  state = {
    loginFailed: false,
    loading: false,
  };

  componentDidMount = async () => {
    const flow = readCheckoutSocialAuth();
    const legacyEnabled =
      this.props.settings.enable_social_auth &&
      this.props.settings.enable_social_auth_staff;
    if (!this.props.forceEnabled && !legacyEnabled && !flow) return;
    // Checkout-v2 callbacks are finalized by the globally mounted overlay so
    // only one provider can consume the token and return path.
    if (flow) return;

    const callback = parseSocialAuthCallback(window.location.search);
    if (!callback.present) return;
    const returnTo = sanitizeSocialAuthReturnTo(
      this.props.returnTo,
      "/profile"
    );
    if (!callback.successful) {
      this.setState({ loginFailed: true });
      this.props.history.replace(returnTo);
      return;
    }
    if (!this.props.auth.user) {
      await this.props.setUser(callback.token, this.props.history);
    }
    this.props.history.replace(returnTo);
  };

  render() {
    const { auth, language, domain } = this.props;
    const { loginFailed } = this.state;
    const legacyEnabled =
      this.props.settings.enable_social_auth &&
      this.props.settings.enable_social_auth_staff;
    if (!this.props.forceEnabled && !legacyEnabled) return null;
    const redirectURL = buildSocialAuthRedirect("google", domain);
    const checkoutV2 = this.props.appearance === "checkout-v2";
    return (
      <div>
        {loginFailed && (
          <p className="bold" style={{ color: "red", marginTop: 10 }}>
            {language == "english"
              ? "Something wrong happened. Please try again later"
              : "حدث خطأ ما. الرجاءالمحاولة لاحقا"}
          </p>
        )}
        {auth.user ? (
          <></>
        ) : (
          <ListItem
            className={checkoutV2 ? "checkout-auth__provider" : undefined}
            component={checkoutV2 ? "button" : "div"}
            type={checkoutV2 ? "button" : undefined}
            disabled={checkoutV2 ? this.props.disabled || this.state.loading : undefined}
            aria-label={checkoutV2 ? language === "english" ? "Continue with Google" : "متابعة باستخدام Google" : undefined}
            style={checkoutV2 ? undefined : { height: 43 }}
            button
            divider={!checkoutV2}
            onClick={() => {
              if (this.props.forceEnabled || this.props.returnTo) {
                beginCheckoutSocialAuth("google", this.props.returnTo);
              }
              this.setState({ loading: true });
              window.location.href = redirectURL;
            }}
          >
            <ListItemIcon>
              <Google style={{ width: 20, height: 20 }} />
            </ListItemIcon>

            {this.state.loading ? (
              <span>
                <CircularProgress
                  style={{
                    width: 25,
                    height: 25,
                    color: "black",
                  }}
                />
              </span>
            ) : (
              <span>{checkoutV2 ? this.props.compact ? "Google" : language === "english" ? "Continue with Google" : "متابعة باستخدام Google" : language == "english" ? "Google" : "جوجل"}</span>
            )}
          </ListItem>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    auth: state.auth,
    settings: state.store.store.settings,
    branch: state.branch,
    domain: state.store.store.domain,
    pickup_only: state.cart.pickup_only_items,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (key, history) => dispatch(setUser(key, history)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(GoogleSocialAuth);
